import { pubmedArticleListing } from '@stereoagency/sanity-schema';
import { CallToAction, Heading, SimpleEntryList } from '@stereoagency/ui';
import flush from 'just-flush';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { linkAsProps } from '@/utils';
import { SimpleBlockContent } from '@/components/sanity/client';

type Props = {
  query?: string;
  articles?: (typeof pubmedArticleListing.schema.pubmedArticleListing)[];
};

export default function GroupOrPlatformPubmedListing({
  query,
  articles
}: Props) {
  const { t } = useTranslation('research-group-or-platform');

  if (!articles?.length) {
    return null;
  }

  return (
    <div>
      <div className="flex justify-between items-center flex-wrap mb-7 md:mb-9">
        <Heading id="publications" as="h2" variant="h2">
          {t('sections.publications.title')}
        </Heading>
        <CallToAction
          buttonType="icon-after"
          variant="button/border"
          className="ml-5"
          target="_blank"
          href={`https://pubmed.ncbi.nlm.nih.gov/?term=${encodeURIComponent(
            query ?? ''
          )}`}
          label={t('sections.publications.action.label')}
          icon={
            <Image
              alt="Pubmed"
              className="block w-auto h-[2rem]"
              width={720}
              height={256}
              src="https://upload.wikimedia.org/wikipedia/commons/f/fb/US-NLM-PubMed-Logo.svg"
            />
          }
        />
      </div>

      <SimpleEntryList
        entries={flush(
          articles.map((article) => {
            if (!article.title || !article.action?.url) return null;
            return {
              title: article.title,
              description:
                typeof article.description === 'string' ? (
                  article.description
                ) :
                article.description?.length ? (
                  <SimpleBlockContent value={article.description ?? []} />
                ) : null,
              action: linkAsProps(article.action)
            };
          })
        )}
      />
    </div>
  );
}
